import { Card } from '@core/types/card-deck';

import { KAMPFKUNST_FEATURE_ID } from '../../types/kampfkunst-features';

export const KAMPFKUNST_FEATURES: Card[] = [
  {
    id: KAMPFKUNST_FEATURE_ID.GrunduebungenFallschule,
    image: 'fallschule',
    name: 'Grundübungen und Fallschule',
    shop: {
      href: 'https://shop.systema-berlin.de/product/grunduebungen',
      video: {
        src: '303021273',
      },
    },
    short: 'Ein starker Körper ist die Grundlage jeder Bewegung.',
    texts1: [
      'Ein starker Körper ist die Grundlage jeder Bewegung. Deswegen enthalten die meisten Trainings Liegestütze, Kniebeugen und Sit-Ups, die wir meist mit verschiedenen Atem-Techniken kombinieren. Du lernst zu regenerieren, zu entspannen und leistungsfähiger zu sein.',
    ],
    texts2: [
      'Darüber hinaus steht das Fallen im Zentrum jedes Trainings. Wir wollen Dir die Angst vorm Fallen nehmen. Egal ob Du einfach ausrutscht, mit dem Fahrrad stürzt oder in einer Konfrontation fallen musst - unsere meisterhafte Fallschule hilft Dir weiter und rettet Leben.',
      'Unsere Fallschule unterscheidet sich stark von allem, was Du vielleicht aus anderen Kampfsportarten kennst. Sie ist für das Fallen auf harten Untergrund optimiert und funktioniert aus jeder beliebigen Position. Du wirst lernen ohne Verletzung auf den Boden zu fallen und Dich dabei präzise zu bewegen. So hat eines unserer Mitglieder sogar den Zusammenstoss mit einem fahrenden Bus ohne große Verletzung überlebt.',
    ],
  },
  {
    id: KAMPFKUNST_FEATURE_ID.BeladenUeberspielen,
    image: 'beladen',
    name: 'Beladen und Überspielen',
    short: 'Meistere Deinen Körper und nutze Fehler des Gegners.',
    texts: [
      'Bei uns im Training dreht sich alles um die harmonische Arbeit mit geringstem Kraft-Einsatz. Wir arbeiten mit Balance und setzen unser Körpergewicht geschickt ein. Nur so ist es möglich, dass Du gegen größere und stärkere Gegner bestehen kannst.',
      'Anstatt mit unseren Muskeln zu drücken oder zu ziehen, lehnen oder hängen wir uns an den Partner und zwingen ihn dadurch, sich an uns anzupassen. Dabei wirkt dann eben nicht unsere Muskelkraft, sondern unser Körpergewicht. Diesen Prozess nennen wir "Beladen".',
      'Je mehr Du Deinen eigenen Körper meisterst, insbesondere Deine Balance und Spannungen, desto mehr kannst Du Fehler beim Partner ausnutzen und ihn dadurch überwinden. Diesen mühelosen Prozess nennen wir "Überspielen". Du gewinnst, indem der Andere verliert.',
    ],
  },
  {
    id: KAMPFKUNST_FEATURE_ID.Atmung,
    image: 'atmung',
    name: 'Atem-Techniken',
    shop: {
      href: 'https://shop.systema-berlin.de/product/grunduebungen2',
      video: {
        src: '303021207',
      },
    },
    short: 'Beeinflusse Deine psychischen und körperlichen Zustände.',
    texts1: [
      'Die Atmung ist zentraler Bestandteil unseres Trainings und Deines Lebens. Mit Hilfe der Atmung können wir unsere psychischen und körperlichen Zustände beeinflussen. Atmung hilft bei der Bewältigung von Angst, Stress und sogar Panik. Atmung kann genutzt werden, um extreme psychische Belastungen zu simulieren oder Schmerz auszuhalten. Atmung hilft bei jeder Entspannung.',
    ],
    texts2: [
      'Im Training lernst Du, wie Du Deine Bewegungen mit der Atmung synchronisieren und Deine Atmung an Deinen körperlichen und psychischen Zustand anpassen kannst.',
    ],
  },
  {
    id: KAMPFKUNST_FEATURE_ID.Gesundheit,
    image: 'massage',
    name: 'Massage, Gesundheit & Sauna',
    shop: {
      href: 'https://shop.systema-berlin.de/product/massage',
      video: {
        src: '303021328',
      },
    },
    short: 'Jedes Training ist ein Beitrag zu Deiner Gesundheit.',
    texts1: [
      'Wir setzen verschiedene Massagen ein, so z.B. Massage mit Händen, Massage mit Füßen, Massage mit Sticks, Massage mit Peitsche oder Messer. Dabei ist unser Ziel, den Partner psychisch und körperlich zu entspannen und an Kontakt mit anderen Menschen zu gewöhnen.',
    ],
    texts2: [
      'Das ganze Training ist darauf ausgelegt, Dich von Deinen Alltags-Spannungen und -Problemen zu befreien und leistet so einen Beitrag zu Deiner Gesundheit. Da wir während des Trainings praktisch ununterbrochen ergonomisch Fallen und wieder aufstehen, wird Dein Körper hervorragend belastet und entspannt.',
      'Jeden Freitag bieten wir Dir die Chance in die Sauna zu gehen. Unsere Aufgüsse werden Deinen Körper und Deine Psyche durcharbeiten und Deine Alltags-Spannung entfernen.',
    ],
  },
  {
    id: KAMPFKUNST_FEATURE_ID.Hebel,
    image: 'hebel',
    name: 'Hebel',
    shop: {
      href: 'https://shop.systema-berlin.de/product/armhebel',
      video: {
        src: '303021437',
      },
    },
    short: 'Bessere Hebel mit Impuls und Körpereinsatz für mehr Wirksamkeit.',
    texts1: [
      'Ein guter Hebel kann zu einem schnellen Sieg führen. Falsch ausgeführt bindet der Hebel aber Deine Hände und verringert Deine Chancen.',
    ],
    texts2: [
      'Wir unterrichten Finger-, Arm- und Handgelenk Hebel, so wie Du sie vermutlich auch aus anderen Kampfsportarten kennst.',
      'Die Kraft für unsere Hebel kommt aus dem Becken und nicht aus dem Oberkörper oder den Armen. Damit sind die Hebel vom Gegner schwerer zu spüren, womit diese sie oft falsch einschätzen und zu spät reagieren. Außerdem können wir dadurch unsere Körpermasse ins Spiel bringen und wesentlich mehr Kraft generieren.',
      'Wir denken Hebel nicht statisch, sondern immer in Bewegung. Dabei nutzen wir die Bewegung des Gegners aus und fügen unsere Impulse hinzu. Entweder wirkt der Hebel in Millisekunden oder er wird durch eine andere Bewegung ersetzt.',
    ],
  },
  {
    id: KAMPFKUNST_FEATURE_ID.NervendruckVitalpunkte,
    image: 'vitalpunkte',
    name: 'Nervendruck und Vitalpunkte',
    short: 'Überleben um jeden Preis. Ansatzlos, vielseitig, kompromislos.',
    texts: [
      'Wenn es um Leben und Tod geht, ist jedes Mittel recht. Nervendruck-Techniken und Angriffe auf Vitalpunkte helfen Dir beim Überleben. Angriffe auf Augen, Ohren, Haare, Hals und andere Schwachstellen gehören zum regelmäßigen Unterrichtsprogramm. Ansatzlos und aus jeder Position.',
      'Im Training lernst Du nicht nur, die entsprechenden Stellen zu erreichen. Wir trainieren auch, wie genau Du sie angreifen musst, um die bestmögliche Wirkung zu erzielen. Du wirst feststellen, dass selbst ein an sich einfacher Fingerstich zum Hals mit unserer Herangehensweise wesentlich verbessert werden kann.',
    ],
  },
  {
    id: KAMPFKUNST_FEATURE_ID.Wuerfe,
    image: 'wuerfe',
    name: 'Würfe',
    short: 'Wir werfen mit Leichtigkeit. Um uns herum statt über uns drüber.',
    texts: [
      'Wir unterrichten Würfe und Selbstfallwürfe. Im Gegensatz zu anderen Kampfsportarten wollen wir den Partner allerdings nicht aus- oder hochheben. Stattdessen suchen wir immer nach dem effizientesten Weg. Häufig nutzen wir dabei unser Körpergewicht, die Kreis-Kräfte und Balance.',
      'Bei der Selbstverteidigung auf der Straße gibt es keine Gewichtsklassen und es macht keinen Sinn, einen wesentlich schwereren Gegner über sich drüber zu werfen. So werfen wir den Gegner lieber um uns herum, und fungieren selbst dabei als Achse. Wie bei einem Tornado stehen wir still, während der Gegner um uns herum beschleunigt.',
    ],
  },
  {
    id: KAMPFKUNST_FEATURE_ID.Schlaege,
    image: 'schlaege',
    name: 'Schläge',
    shop: {
      href: 'https://shop.systema-berlin.de/product/schlaege',
      video: {
        src: '347957045',
      },
    },
    short: 'Schlagen und Geschlagen werden. Training von Körper, Psyche und Atmung.',
    texts1: [
      'Wir unterrichten ein breites Spektrum an Schlägen und auch die Aufnahme von Vollkontakt-Schlägen mit dem Körper ("Eisenkörper"). Trainiert werden sowohl kurze, unsichtbare als auch tiefe Schläge. Wir legen den Schwerpunkt darauf, jeden Schlag mit Unterstützung des Körpers auszuführen und den Rückstoß zu minimieren.',
    ],
    texts2: [
      'Das Abbekommen von Schlägen trainiert gleichermaßen Körper, Psyche und Atmung. Es ist ein hervorragendes Mittel, um Stress zu simulieren und zu lernen damit umzugehen.',
    ],
    video: {
      horizontal: true,
      src: '1007427508',
    },
  },
];
